module.exports = __webpack_public_path__ + "img/talent-search.e84db5a3.svg";